import { Locale } from 'date-fns';
import { de, enGB, es, fi, fr, it, pt } from 'date-fns/locale';

export class TinyHelper {
    public static createTmpId(prefix = '') {
        return prefix + Math.random().toString(36).substr(2, 9);
    }

    public static deepCopy<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
    }

    public static unique(value, index, self) {
        return self.indexOf(value) === index;
    }

    public static countryCodeToLocale(countryCode: string): Locale {
        switch (countryCode.toLowerCase()) {
            case 'de':
                return de;
            case 'en':
                return enGB;
            case 'es':
                return es;
            case 'fi':
                return fi;
            case 'fr':
                return fr;
            case 'it':
                return it;
            case 'pt':
                return pt;
            default:
                return de;
        }
    }

    public static updateDateFormat(currentFormat: string, currentLang: string): string {
        if (currentLang.toLowerCase() === 'en') {
            switch (currentFormat) {
                case 'd. MMMM yyyy':
                    currentFormat = 'MMMM dd, yyyy';
                    break;
                case 'dd. LLL. yyyy':
                    currentFormat = 'MMM. dd, yyyy';
                    break;
                case 'dd.MM.yyyy':
                    currentFormat = 'yyyy-MM-dd';
                    break;
                default:
                    break;
            }
        } else {
            switch (currentFormat) {
                case 'MMMM dd, yyyy':
                    currentFormat = 'd. MMMM yyyy';
                    break;
                case 'MMM. dd, yyyy':
                    currentFormat = 'dd. LLL. yyyy';
                    break;
                case 'MM/dd/yyyy':
                    currentFormat = 'dd. LLL. yyyy';
                    break;
                case 'yyyy-MM-dd':
                    currentFormat = 'dd.MM.yyyy';
                    break;
                default:
                    break;
            }
        }
        return currentFormat;
    }

    /**
     * Get the long country name and display it in the selected language
     * @param countryShort The short country name
     * @param language The language in which the country name should be displayed
     * @returns The long country name, if it exists, otherwise undefined
     */
    public static getCountryLong(countryShort: string, language: string): string | undefined {
        if (!countryShort || !language || !Intl?.DisplayNames) {
            return undefined;
        }

        const normalizedLanguage = language.toLowerCase() === 'en' ? 'en-GB' : language;

        try {
            const displayNames = new Intl.DisplayNames([normalizedLanguage, 'en'], { type: 'region' });
            return displayNames.of(countryShort.toUpperCase());
        } catch {
            return undefined;
        }
    }
}
